<script lang="ts">
import { defineComponent, h, ref } from 'vue';
import { useBlockInteractiveZone } from '#layers/block-engine/utils/block/interactive-zone';

/**
 * Renders an explicit interactive region for block content inside the builder.
 */
export default defineComponent({
	name: 'BlockInteractiveZone',
	inheritAttrs: false,
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	setup(props, { attrs, slots }) {
		const wrapperRef = ref<HTMLElement | null>(null);
		const { active } = useBlockInteractiveZone(wrapperRef, () => props.disabled);

		return () => {
			const children = slots.default?.() ?? [];

			if (!active.value) {
				return children;
			}

			return h('div', {
				...attrs,
				ref: wrapperRef,
				class: ['pointer-events-auto', attrs.class],
				style: [
					attrs.style,
					{ display: 'contents' },
				],
			}, children);
		};
	},
});
</script>
